// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branding-section {
  margin-bottom: 40px;
}

.login-form-section {
  margin-bottom: 30px;
}

.nav-section {
  margin-bottom: 60px;
}

.brand-desc {
  font-weight: 600;
  font-size: 30px;
  line-height: 120%;
  display: flex;
  flex-direction: column;
  padding: 16px 0px;
  margin: 0;
  color: #4f4f4f;
}

.error-border {
  border-color: var(--color-error);
}

.invalid {
  border-color: #d0011b;
}

.valid {
  border-color: var(--color-secondary);
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/mobile/login/login.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AACA;EACE,qBAAA;AAEF;;AAAA;EACE,oCAAA;EACA,gBAAA;AAGF","sourcesContent":[".branding-section {\n  margin-bottom: 40px;\n}\n\n.login-form-section {\n  margin-bottom: 30px;\n}\n\n.nav-section {\n  margin-bottom: 60px;\n}\n\n.brand-desc {\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 120%;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 0px;\n  margin: 0;\n  color: #4f4f4f;\n}\n\n.error-border {\n  border-color: var(--color-error);\n}\n.invalid {\n  border-color: #d0011b;\n}\n.valid {\n  border-color: var(--color-secondary);\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
